module.exports = __webpack_public_path__ + "img/a123_5.8f2aab81.webp";